import { connect } from "react-redux";
import AudioVideo from "./components";
import { getAudiosBySerie, getYoutubePlaylist } from "../../actions";
import { AUDIO_SERIES } from "../../common/constants";

const mapStateToProps = (state) => ({
  getCharlesSpurgeonAudios: ({ pageCount }) =>
    getAudiosBySerie(AUDIO_SERIES.SPURGEON, pageCount),
  getHereWeStand: ({ pageCount }) =>
    getAudiosBySerie(AUDIO_SERIES.HERE_WE_STAND, pageCount),
  getPastoralTheology: ({ pageCount }) =>
    getAudiosBySerie(AUDIO_SERIES.LECTURES_IN_PASTORAL_THEOLOGY, pageCount),
  getConferences: ({ pageCount }) =>
    getAudiosBySerie(AUDIO_SERIES.CONFERENCES, pageCount),
  getLeeRoyShelton: ({ pageCount }) =>
    getAudiosBySerie(AUDIO_SERIES.LEEROY_SHELTON, pageCount),
  getYoutubePlaylist,
});

export default connect(mapStateToProps)(AudioVideo);
